import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Layout } from './components/layout';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import DeviceInfo from './pages/DeviceInfo';
import { Subjects } from './pages/Subjects';
import { Quiz } from './pages/Quiz';
import { Results } from './pages/Results';
import { Profile } from './pages/Profile';
import { Credits } from './pages/Credits';
import { SystemStatus } from './pages/SystemStatus';
import { ProtectedRoute } from './components/ProtectedRoute';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/device-info" element={<DeviceInfo />} />
              
              {/* Protected routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout 
                    pageTitle="Dashboard" 
                    pageSubtitle="Benvenuto su Live Concorsi"
                    backgroundClassName="bg-gradient-to-br from-blue-50 via-blue-25 to-indigo-50"
                    backgroundStyle={{
                      background: 'linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(219, 234, 254, 0.6) 50%, rgba(238, 242, 255, 0.8) 100%)'
                    }}
                  >
                    <Home />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Layout 
                    pageTitle="Dashboard" 
                    pageSubtitle="Benvenuto su Live Concorsi"
                    backgroundClassName="bg-gradient-to-br from-blue-50 via-blue-25 to-indigo-50"
                    backgroundStyle={{
                      background: 'linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(219, 234, 254, 0.6) 50%, rgba(238, 242, 255, 0.8) 100%)'
                    }}
                  >
                    <Home />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/subjects" element={
                <ProtectedRoute>
                  <Layout pageTitle="Materie" pageSubtitle="Scegli una materia e inizia il tuo quiz">
                    <Subjects />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/quiz/:sessionId" element={
                <ProtectedRoute>
                  <Layout pageTitle="Quiz" pageSubtitle="Rispondi alle domande" showPageHeader={false} showFooter={false}>
                    <Quiz />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/results/:sessionId" element={
                <ProtectedRoute>
                  <Layout pageTitle="Risultati Quiz" pageSubtitle="Visualizza i tuoi risultati" showPageHeader={false} showFooter={true}>
                    <Results />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <Layout pageTitle="Profilo" pageSubtitle="Le tue statistiche e informazioni">
                    <Profile />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/credits" element={
                <ProtectedRoute>
                  <Layout pageTitle="Credits" pageSubtitle="Informazioni sui creatori dell'applicazione">
                    <Credits />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/system-status" element={
                <ProtectedRoute>
                  <Layout pageTitle="Stato del Sistema" pageSubtitle="Monitoraggio del sistema">
                    <SystemStatus />
                  </Layout>
                </ProtectedRoute>
              } />
            </Routes>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;